import React from 'react';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import Panel from '../../../../../components/outline/Panel';
import Table from '../../../../../components/table/Table';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import LabelInfo from '../../../../../components/LabelInfo';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import { setDash, setPhoneFormat } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  ACCOUNT_USER_GENDER_TYPE_TEXT,
  ACCOUNT_USER_LOGIN_TYPE_TEXT,
  ACCOUNT_USER_STATUS_TEXT,
} from '../../../../../constants/service/app/accountUserConstants';
import {
  CS_INQUIRY_DETAIL_LATEST_ORDER_TABLE_EMPTY_TEXT,
  CS_INQUIRY_DETAIL_USERS_OTHER_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/csInquiryConstants';
import { AMONDZ_MEMBER_TYPE } from '../../../../../constants/service/common/utilConstants';
import { latestOrderColumns, usersOtherInquiryColumns } from './columns';
import './CsInquiryDetailUserInfo.scss';

const CsInquiryDetailUserInfo = (props) => {
  const { userInfo, getUsersOtherInquiryList } = props;
  const { list, pagination, summary } = userInfo.usersOtherInquiry;

  return (
    <Panel className="cs-inquiry-detail-user-info">
      <div className="panel-header">
        <div className="title">유저 정보</div>
      </div>

      <div className="panel-body">
        <div className="user-info">
          <div className="form-wrap">
            <LabelInfo label="로그인 타입" info={setDash(ACCOUNT_USER_LOGIN_TYPE_TEXT[userInfo.loginType])} />

            <LabelInfo label="이메일" info={setDash(userInfo.email)} />

            <LabelInfo
              label="핸드폰 번호"
              info={
                <SendMessageService
                  text={setPhoneFormat(userInfo.cellPhone)}
                  memberType={AMONDZ_MEMBER_TYPE.USER}
                  targetId={userInfo.userId}
                />
              }
            />

            <LabelInfo label="가입일자" info={setDateFormat(userInfo.createDate)} />
          </div>

          <div className="form-wrap">
            <LabelInfo label="이름" info={setDash(userInfo.name)} />

            <LabelInfo label="생년월일" info={setDateFormat(userInfo.birthday)} />

            <LabelInfo label="성별" info={setDash(ACCOUNT_USER_GENDER_TYPE_TEXT[userInfo.gender])} />
          </div>

          <div className="form-wrap">
            <LabelInfo label="유저 식별 ID" info={<OpenUserDetail text={userInfo.userId} userId={userInfo.userId} />} />

            <LabelInfo label="친구초대 코드" info={setDash(userInfo.referralCode)} />

            <LabelInfo label="계정 상태" info={ACCOUNT_USER_STATUS_TEXT[userInfo.status]} />
          </div>
        </div>

        <div className="user-device">
          <div className="title">디바이스 정보</div>

          <div className="user-device-info">
            <div className="form-wrap">
              <LabelInfo label="기종명" info={setDash(userInfo.modelName)} />

              <LabelInfo label="AMONDZ 앱 버전" info={setDash(userInfo.appVersion)} />
            </div>

            <div className="form-wrap">
              <LabelInfo label="기기 sdk 버전" info={setDash(userInfo.sdk)} />
            </div>

            <div className="form-wrap">
              <LabelInfo label="os 종류 및 버전" info={setDash(userInfo.os)} />
            </div>
          </div>
        </div>

        <div className="latest-order-info">
          <div className="title">최근에 주문한 주문서 정보</div>

          <Table
            data={userInfo.latestOrderItemList}
            isStriped={true}
            emptyText={CS_INQUIRY_DETAIL_LATEST_ORDER_TABLE_EMPTY_TEXT}
            showPagination={false}
            columns={() => latestOrderColumns()}
          />
        </div>

        <div className="users-other-inquiry-list">
          <div className="title">이 사람의 다른 문의 내역 조회하기</div>

          <TableWithSummary
            data={list}
            totalCnt={summary.totalCnt}
            initialOption={{ pagination: LIST_PAGINATION_MODEL }}
            isStriped={true}
            emptyText={CS_INQUIRY_DETAIL_USERS_OTHER_TABLE_EMPTY_TEXT}
            showPagination
            pagination={pagination}
            getList={getUsersOtherInquiryList}
            columns={(utils) =>
              usersOtherInquiryColumns({
                ...utils,
              })
            }
          />
        </div>
      </div>
    </Panel>
  );
};

export default CsInquiryDetailUserInfo;
